export const logisticsConst = {
  path: "/single-programs/logistics",
  title: "ФАКУЛЬТЕТ БИЗНЕСА – ЛОГИСТИКА",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Логистика — профессия, которая держит мир в движении</h2>
      <p>
        Каждый товар, который вы держите в руках, прошел сложный путь: от производства — до полки магазина. Именно логистика управляет этим
        движением. Это стратегически важная область бизнеса, которая требует точности, аналитического мышления и умения работать в
        глобальной системе.
      </p>
      <p>
        Программа обучения охватывает все ключевые этапы логистических процессов: от управления цепочками поставок до международных
        перевозок и складской логистики. Вы научитесь обеспечивать бесперебойную доставку товаров, контролировать запасы и оптимизировать
        затраты компаний.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Управление цепями поставок (Supply Chain Management)</li>
        <li>Международная и внутренняя логистика</li>
        <li>Транспортные системы и маршрутизация</li>
        <li>Логистика на складах и управление запасами</li>
        <li>Экономика и финансы в логистике</li>
        <li>IT-системы и цифровые платформы (SAP, 1C, ERP)</li>
        <li>Таможенное регулирование и ВЭД</li>
        <li>Анализ логистических рисков и устойчивость поставок</li>
        <li>Закупки, снабжение и логистика e-commerce</li>
      </ul>
      <p>Занятия включают реальные кейсы, моделирование цепочек поставок, работу с логистическими платформами и проектами.</p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Специалист по логистике и снабжению</li>
        <li>Supply chain-менеджер</li>
        <li>Менеджер по складской или транспортной логистике</li>
        <li>Специалист по международным перевозкам</li>
        <li>Координатор логистических проектов</li>
        <li>Консультант в логистических компаниях или ритейле</li>
        <li>Руководитель логистического отдела на производстве или в торговле</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€50,000 до €90,000 в год,</strong> в зависимости от страны, отрасли и опыта.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом с международным признанием</li>
        <li>Гибкий график обучения: очно или дистанционно</li>
        <li>Практика в логистических центрах, складах, транспортных компаниях</li>
        <li>Обучение на русском или английском языке (на выбор)</li>
        <li>Курсы по международной логистике, ВЭД и e-commerce</li>
        <li>Поддержка на каждом этапе — от поступления до трудоустройства</li>
      </ul>
      <p>
        Логистика — это профессия, без которой невозможно представить современный бизнес. Здесь ценят точность, скорость и умение находить
        решения в сложных ситуациях.
      </p>
      <h2>Как поступить?</h2>
      <p>
        Наша приёмная комиссия поможет вам подобрать удобную форму обучения, собрать документы и уверенно начать обучение в европейском
        вузе.
      </p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Логистика — профессия, которая держит мир в движении
    Каждый товар, который вы держите в руках, прошел сложный путь: от производства — до полки магазина. Именно логистика управляет этим движением. Это стратегически важная область бизнеса, которая требует точности, аналитического мышления и умения работать в глобальной системе.
    Программа обучения охватывает все ключевые этапы логистических процессов: от управления цепочками поставок до международных перевозок и складской логистики. Вы научитесь обеспечивать бесперебойную доставку товаров, контролировать запасы и оптимизировать затраты компаний.

    Что вы будете изучать?
    • Управление цепями поставок (Supply Chain Management)
    • Международная и внутренняя логистика
    • Транспортные системы и маршрутизация
    • Логистика на складах и управление запасами
    • Экономика и финансы в логистике
    • IT-системы и цифровые платформы (SAP, 1C, ERP)
    • Таможенное регулирование и ВЭД
    • Анализ логистических рисков и устойчивость поставок
    • Закупки, снабжение и логистика e-commerce
    Занятия включают реальные кейсы, моделирование цепочек поставок, работу с логистическими платформами и проектами.

    Кем можно работать после окончания?
    • Специалист по логистике и снабжению
    • Supply chain-менеджер
    • Менеджер по складской или транспортной логистике
    • Специалист по международным перевозкам
    • Координатор логистических проектов
    • Консультант в логистических компаниях или ритейле
    • Руководитель логистического отдела на производстве или в торговле

    Средний доход в Европе:
    от €50,000 до €90,000 в год, в зависимости от страны, отрасли и опыта.

    Почему выбирают нас?
    • Европейский диплом с международным признанием
    • Гибкий график обучения: очно или дистанционно
    • Практика в логистических центрах, складах, транспортных компаниях
    • Обучение на русском или английском языке (на выбор)
    • Курсы по международной логистике, ВЭД и e-commerce
    • Поддержка на каждом этапе — от поступления до трудоустройства

    Логистика — это профессия, без которой невозможно представить современный бизнес. Здесь ценят точность, скорость и умение находить решения в сложных ситуациях.

    Как поступить?
    Наша приёмная комиссия поможет вам подобрать удобную форму обучения, собрать документы и уверенно начать обучение в европейском вузе.
  `,
};
